<template>
  <div style="position: relative">
    <TwoPage>
      <template #heard>
        <div>
          <div
            ref="twoTitleWatch"
            data-index="twoTitleWatch"
            style="color: #fff6f6; font-size: 32px; margin-bottom: 12px"
            class="shake2"
          >
            {{ t("two.title") }}
          </div>
          <div
            style="
              color: #fef8f8;
              font-size: 16px;
              margin-bottom: 20px;
              padding: 0 16px;
              max-width: 450px;
            "
          >
            {{ t("two.details") }}
          </div>
        </div>
      </template>
      <template #download>
        <div
          ref="dowContainerWatch"
          data-index="dowContainerWatch"
          style="margin-top: 32px"
          class="tow_bottom_box"
        >
          <!-- <div class="button_box">
            <a style="all: unset;cursor: pointer;display: flex;" href="https://apps.apple.com/app/id6499319651"> <img
                src="./assets/ios.svg" style="margin-right: 4px;" width="18px" alt="">
              ios下载</a>

          </div>
          <div class="button_box_r" style="margin-left: 12px;">
            <a style="all: unset;cursor: pointer;display: flex;"
              href="https://lingxi.enewie.com/babel/download?apid=BABEL&os=ANDROID">
              <img src="./assets/android.svg" style="margin-right: 4px;" width="18px" alt="">
              android下载
            </a>
          </div> -->
          <div class="tow_bottom_box">
            <div
              v-show="showLeft"
              @click="onMainSwich"
              class="button_box tip_button"
            >
              {{ t("two.exchange") }}
            </div>
            <div
              v-show="showRight"
              @animationend="onRightAnimationEnd"
              class="button_box_r download_up_squish"
              style="width: 180px; margin-left: 12px"
            >
              <a
                style="
                  all: unset;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  margin-right: 18px;
                "
                href="https://apps.apple.com/app/id6499319651"
              >
                <img
                  src="./assets/ios.svg"
                  style="margin-right: 4px"
                  width="18px"
                  alt=""
                />
                ios</a
              >
              <a
                @click="onOpenModle"
                style="
                  all: unset;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                "
              >
                <img
                  src="./assets/android.svg"
                  style="margin-right: 4px"
                  width="18px"
                  alt=""
                />
                android
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #tip>
        <img
          style="cursor: pointer"
          @click="goToThree"
          v-show="tipVisible"
          src="./assets/down.svg"
          width="15px"
          alt=""
        />
      </template>
    </TwoPage>
    <ThreePage ref="childRefThree" @notify="handleNotify" />
    <FourPage />
    <FivePage />
    <SixPage />
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 24px;
      "
    >
      <div style="font-size: 16px; font-weight: 500; margin-bottom: 12px">
        {{ t("video.title") }}
      </div>
      <iframe
        class="eNewie_iframe_bilibili"
        src="//player.bilibili.com/player.html?isOutside=true&aid=115569936375217&bvid=BV1qKygBNEXq&cid=34088095485&p=1"
        scrolling="no"
        border="0"
        frameborder="no"
        framespacing="0"
        allowfullscreen="true"
      ></iframe>
    </div>
    <a-modal
      v-model:open="openAndroidModle"
      :footer="null"
      :maskClosable="false"
      centered
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-bottom: 12px;
        "
      >
        <div style="text-align: center; font-size: 15px; font-weight: 500">
          {{ t("download.title") }}
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 12px;
          "
        >
          <!-- <div class="android_button_box">
            <a
              style="
                all: unset;
                cursor: pointer;
                display: flex;
                align-items: center;
              "
              href="https://lingxi.enewie.com/babel/download?apid=BABEL&os=ANDROID"
            >
              <img
                src="./assets/android_package.svg"
                width="20px"
                style="margin-right: 4px"
                alt=""
              />
              {{ t("download.package") }}</a
            >
          </div> -->
          <div class="android_button_box">
            <a
              style="
                all: unset;
                cursor: pointer;
                display: flex;
                align-items: center;
              "
              href="https://a.app.qq.com/o/simple.jsp?pkgname=com.enewie.babel"
            >
              <img
                src="./assets/yingyongbao.svg"
                width="20px"
                style="margin-right: 4px"
                alt=""
              />
              应用宝</a
            >
          </div>
          <div class="android_button_box">
            <a
              style="
                all: unset;
                cursor: pointer;
                display: flex;
                align-items: center;
              "
              href="https://play.google.com/store/apps/details?id=com.enewie.babel"
            >
              <img
                src="./assets/google_play.svg"
                width="20px"
                style="margin-right: 4px"
                alt=""
              />
              Google Play
            </a>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import TwoPage from "./components/TwoPage.vue";
import ThreePage from "./components/ThreePage.vue";
import FourPage from "./components/FourPage.vue";
import FivePage from "./components/FivePage.vue";
import SixPage from "./components/SixPage.vue";

import { ref, onMounted, defineEmits } from "vue";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();

const lang = ref("zh");
if (locale.value != "zh-CN" && locale.value != "zh") {
  lang.value = "en";
}

document.title = lang.value == "en" ? "Lingxi" : "灵犀";

const emit = defineEmits(["showBar", "swichUse"]); //给父组件发送是否显示顶部bar
const dowContainerWatch = ref(null);
const twoTitleWatch = ref(null);

// const isVisible = ref(true); //顶部bar按钮
const tipVisible = ref(false); //向下滑按钮

const handleNotify = (value) => {
  tipVisible.value = !value;
};

// 底部三个动画按钮实现
const showLeft = ref(false); //兑换码
const showRight = ref(false); //下载按钮
function onRightAnimationEnd() {
  showLeft.value = true;
}

const onMainSwich = () => {
  emit("swichUse", true);
};

const openAndroidModle = ref(false); //打开弹框
//  href="https://lingxi.enewie.com/babel/download?apid=BABEL&os=ANDROID"
const onOpenModle = () => {
  openAndroidModle.value = true;
};

const childRefThree = ref(null);
const goToThree = () => {
  let element = dowContainerWatch.value;
  const offset = 20; // 想留的空隙

  const top =
    element.getBoundingClientRect().top +
    window.pageYOffset +
    element.offsetHeight +
    offset;
  window.scrollTo({
    top,
    behavior: "smooth",
  });
};

onMounted(() => {
  const observer = new IntersectionObserver(
    (entry) => {
      entry.forEach((item) => {
        const idx = item.target.dataset.index;
        const entryItem = item.isIntersecting; //显示or隐藏
        if (idx == "dowContainerWatch") {
          setTimeout(() => {
            emit("showBar", entryItem);
            // isVisible.value = entryItem;
          }, 500);
          // 首次加载
          if (entryItem && !showRight.value) {
            setTimeout(() => {
              showRight.value = true;
            }, 2500);
            setTimeout(() => {
              tipVisible.value = true;
            }, 4500);
          }
        }
        //使用下滑提示
        if (idx == "twoTitleWatch") {
          if (showRight.value) {
            tipVisible.value = entryItem;
          }
        }
      });
    },
    {
      threshold: [0.9, 1, 0.1],
    },
  );
  if (dowContainerWatch.value) {
    observer.observe(dowContainerWatch.value);
  }
  if (twoTitleWatch.value) {
    observer.observe(twoTitleWatch.value);
  }
});
</script>

<style>
.ant-modal .ant-modal-content {
  background-color: #0b111d;
  /* 9C76B1 */
  color: white;
  border: 2px solid #1d2d5486;
  padding: 20px 12px;
}

.ant-modal .ant-modal-close {
  color: white;
}

.android_button_box {
  padding: 6px 12px;
  display: flex;
  align-items: center;
  font-size: 12px;
}

.tow_bottom_box {
  display: flex;
  justify-content: center;
  font-size: 16px;
}

.button_box {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("./assets/bg_pic_canguanfang.png");
  background-position: right -88px bottom -54px;
  background-color: #05050596;
  padding: 8px 0;
  width: 90px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
}

.button_box_r {
  display: flex;
  justify-content: center;
  background-image: url("./assets/bg_pic_zhubanfang.png");
  background-position: right -88px bottom -54px;
  background-color: #05050598;
  padding: 8px 0;
  /* width: 130px; */
  border-radius: 6px;
  /* color: #050505; */
  font-weight: 500;
  font-size: 16px;
}

.media_screen_style {
  min-height: 932px;
}

.media_section_height {
  height: max(932px, 100svh);
  /* background-color: aquamarine; */
}

.detail_page_scale {
  transform: scale(1);
  transform-origin: top;
}

/* 0.7尺寸 */
@media screen and (min-width: 301px) and (min-height: 653px) {
  .media_screen_style {
    transform: scale(0.7);
    transform-origin: top;
    min-height: 653px;
  }

  .media_section_height {
    /* background-color: aqua; */
    height: max(653px, 100svh);
    /* background-color: rgb(127, 223, 255); */
  }

  .detail_page_scale {
    transform: scale(0.7);
    transform-origin: top;
  }
}

/* 0.8尺寸 */
@media screen and (min-width: 344px) and (min-height: 746px) {
  .media_screen_style {
    transform: scale(0.8);
    transform-origin: top;
    min-height: 746px;
  }

  .media_section_height {
    height: max(746px, 100svh);
    /* background-color: rgb(251, 255, 127); */
  }

  .detail_page_scale {
    transform: scale(0.8);
    transform-origin: top;
  }
}

/* 0.88尺寸 */
@media screen and (min-width: 380px) and (min-height: 822px) {
  .media_screen_style {
    transform: scale(0.88);
    transform-origin: top;
    min-height: 822px;
  }

  .media_section_height {
    height: max(822px, 100svh);
    /* background-color: rgb(176, 127, 255); */
  }

  .detail_page_scale {
    transform: scale(0.88);
    transform-origin: top;
  }
}

/* 1尺寸 */
@media screen and (min-width: 430px) and (min-height: 932px) {
  .media_screen_style {
    transform: scale(1);
    transform-origin: top;
    min-height: 932px;
  }

  .media_section_height {
    height: max(932px, 100svh);
    /* background-color: rgb(255, 180, 127); */
  }

  .detail_page_scale {
    transform: scale(1);
    transform-origin: top;
  }
}
</style>

<style scoped>
.eNewie_iframe_bilibili {
  border-radius: 4px;
  border: 2px solid #1d2d54b4;
}

.tip_button {
  /* opacity: 0; */
  transform: scale(0.5) translateX(0);
  animation: tipButtonBounce 1s ease-out forwards;
}

@keyframes tipButtonBounce {
  0% {
    opacity: 0;
    transform: scale(0.5) translateX(0);
  }

  40% {
    opacity: 1;
    transform: scale(1.1) translateX(0);
    /* 爆炸放大 */
  }

  60% {
    transform: scale(1) translateX(10px);
    /* 往右挤 */
  }

  80% {
    transform: scale(1) translateX(-5px);
    /* 回弹一点 */
  }

  100% {
    transform: scale(1) translateX(0);
    /* 稳定原位 */
  }
}

@keyframes buttonBoxRSquish {
  0% {
    transform: translateX(0);
  }

  40% {
    transform: translateX(30px);
  }

  70% {
    transform: translateX(15px);
  }

  100% {
    transform: translateX(0);
  }
}

.squishRight {
  animation: buttonBoxRSquish 1s ease-out;
  animation-delay: 0.1s;
  /* 稍后一点开始挤 */
}

/* 下载按钮往上滑动 */
@keyframes downloadPopUpSquish {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }

  30% {
    opacity: 1;
    transform: translateY(-10px) scale(1.05);
  }

  50% {
    transform: translateY(0) scale(1);
  }

  /* 70% {
    transform: translateX(30px);
  }

  85% {
    transform: translateX(15px);
  } */

  100% {
    transform: translateX(0);
  }
}

.download_up_squish {
  animation: downloadPopUpSquish 1s ease-out forwards;
}
</style>
